import request from "/utils/request";

const loadAccounts = () => {
  return request.get("/nc/settings/account_list");
};

const unlinkSocialAccount = (type) => request
  .delete("/api/social_accounts", {
    params: { type },
    token: true
  });

const addLogin = (email, password) => request
  .post("/api/blinkist_account", {
    body: { email, password },
    token: true
  });

const changePassword = (oldPassword, newPassword) => request
  .put("/api/password", {
    body: {
      old_password: oldPassword, /* eslint-disable-line camelcase */
      password1: newPassword,
      password2: newPassword
    },
    token: true
  });

const changeEmail = (email, password) => request
  .put("/api/blinkist_account", {
    body: {
      email,
      password
    },
    token: true
  });

export default {
  loadAccounts,
  unlinkSocialAccount,
  addLogin,
  changePassword,
  changeEmail
};
